import { Row, Col, Card, Table, DatePicker, Tag } from "antd";

import React, { useState, useEffect } from "react";

import moment from "moment";
import lang from "../../helper/langHelper";
const { RangePicker } = DatePicker;

function LastProducts({ data, loading }) {
  const [list, setList] = useState(data);
  const [pagination, setPagination] = useState(5);

  useEffect(() => {
    if (!data) return;
    setList(data);
    setPagination(data?.length);
    console.log("data ::", data);
  }, [data]);

  const columns = [
    {
      title: "Order ID",
      dataIndex: "orderId",
      key: "orderId",
      render: (_, { orderId }, idx) => {
        return <span className="">{orderId || "87426" + idx}</span>;
      },
    },
    {
      title: "Customer",
      dataIndex: "userId",
      key: "userId",
      render: (_, { userId }) => {
        return (
          <span className="">
            {userId?.name}, {userId?.email}
          </span>
        );
      },
    },
    {
      title: "Vendor",
      dataIndex: "vendorId",
      key: "vendorId",
      render: (_, { vendorId }) => {
        return (
          <span className="">
            {vendorId?.name}, {vendorId?.email}
          </span>
        );
      },
    },
    {
      title: "Amount (AED)",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Date & Time",
      dataIndex: "dateTime",
      key: "dateTime",
      render: (_, { created_at }) => {
        return <span className="">{created_at ? moment(created_at).format("lll") : "NA"}</span>;
      },
    },
    {
      title: "Items",
      dataIndex: "items",
      key: "items",
      render: (_, { items }) => {
        return (
          items?.map((item, idx) => {
            return <><span>{item?.productId?.name || "Item"} x {item?.quantity}</span><br /></>
          })
        )
      },
    },
    {
      title: "Delivery Address",
      dataIndex: "addressId",
      key: "addressId",
      render: (_, { addressId }) => {
        return (
          <>
            <span>Address : {addressId?.address || "NA"}</span><br />
            <span>City : {addressId?.city || "NA"}</span><br />
            <span>Postal Code : {addressId?.postalCode || "NA"}</span><br />
            <span>Phone Number : +{addressId?.countryCode + " " + addressId?.mobileNumber}</span><br />
          </>
        );
      },
    },
    {
      title: "Order Status",
      key: "orderStatus",
      render: (_, { orderStatus, _id }) => {
        let color = orderStatus === "delivered" ? "green" : orderStatus === "cancelled" ? "red" : orderStatus === "refunded" ? "orange" : "blue";
        return (
          <Tag
            // onClick={() => showConfirm(_id)} 
            color={color}
            key={orderStatus}
          >
            {orderStatus || ""}
          </Tag>
        );
      },
    },
  ];

  return (
    <>
      <div className="tabled bannerMain">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <div className="table-responsive customPagination">
              <Table
                loading={loading}
                columns={columns}
                dataSource={list}
                pagination={{
                  defaultPageSize: 10,
                  responsive: true,
                  total: pagination,
                  // showSizeChanger: true,
                  // pageSizeOptions: ["10", "20", "30", "50"],
                }}
                className="ant-border-space"
              />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default LastProducts;
